module.exports = __webpack_public_path__ + "media/icons/lock-f6076872.svg";